import CommissionSalesGroupsPage from "../../pages/legacy/commissionSalesGroups/CommissionSalesGroupsPage";

const route = {
  key: "commissionSalesGroups",
  path: "/legacy/commission-sales-groups",
  component: CommissionSalesGroupsPage,
  private: true,
  layout: "main",
  icon: "faTable",
  group: "configuration",
  order: 10,
  permission: "legacy.commissionSalesGroups.read"
};

export default route;